import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <h1 className="text-4xl font-bold text-[#2d3c5d] mb-4">Política de Privacidad</h1>
          <p className="text-gray-600">
            Última actualización: {new Date().toLocaleDateString('es-AR')}
          </p>
        </div>

        {/* Contenido */}
        <div className="bg-white rounded-lg shadow-lg p-8 space-y-8">
          {/* 1. Aceptación */}
          <section>
            <h2 className="text-2xl font-bold text-[#2d3c5d] mb-4">1. Aceptación</h2>
            <div className="text-gray-700 space-y-3">
              <p>
                Al utilizar los servicios de <strong>Deco Home Sin Rival SRL</strong> ("la Empresa") disponibles en{' '}
                <a href="https://decohomesinrival.com.ar" className="text-[#2d3c5d] hover:underline">
                  https://decohomesinrival.com.ar
                </a>{' '}
                ("el Sitio"), aceptás en forma plena y sin reservas esta Política de Privacidad, así como los Términos y Condiciones vigentes.
              </p>
              <p>
                La Empresa podrá modificar esta Política en cualquier momento, publicando la versión actualizada en el Sitio y/o notificando por correo electrónico. El uso continuado del Sitio tras esos cambios implicará tu aceptación de los mismos.
              </p>
              <p>
                Para consultas sobre la política:{' '}
                <a href="mailto:info@decohomesinrival.com.ar" className="text-[#2d3c5d] hover:underline">
                  info@decohomesinrival.com.ar
                </a>
              </p>
            </div>
          </section>

          {/* 2. Servicios prestados */}
          <section>
            <h2 className="text-2xl font-bold text-[#2d3c5d] mb-4">2. Servicios prestados</h2>
            <p className="text-gray-700">
              El Sitio funciona como tienda online para la venta de productos (decoración, muebles, etc.).
            </p>
          </section>

          {/* 3. Datos que recabamos */}
          <section>
            <h2 className="text-2xl font-bold text-[#2d3c5d] mb-4">3. Datos que recabamos y finalidad</h2>
            <div className="text-gray-700 space-y-3">
              <p>
                Recabamos información que vos nos proporcionás directamente (nombre, apellido, correo electrónico, teléfono, dirección, código postal, ciudad) y datos indirectos mediante cookies, tags u otros mecanismos (dirección IP, comportamiento de navegación, páginas visitadas, etc.).
              </p>
              <p>Utilizamos estos datos para:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>procesar tus compras</li>
                <li>personalizar la experiencia de uso</li>
                <li>enviar ofertas, promociones, noticias</li>
                <li>mejorar los servicios del Sitio</li>
                <li>analizar comportamientos de consumo</li>
                <li>cumplir requerimientos legales</li>
              </ul>
              <p>
                <strong>No almacenamos datos sensibles de medios de pago:</strong> la información de tarjetas u otros medios financieros será manejada exclusivamente por la pasarela de pagos (Mercado Pago) sin que la Empresa tenga acceso directo a esos datos.
              </p>
            </div>
          </section>

          {/* 4. Cookies */}
          <section>
            <h2 className="text-2xl font-bold text-[#2d3c5d] mb-4">4. Cookies y herramientas de seguimiento</h2>
            <div className="text-gray-700 space-y-3">
              <p>
                Usamos cookies, tags y tecnologías similares para registrar actividad de navegación, preferencias y optimizar los servicios. No obtenemos datos personales directamente mediante cookies (a menos que vos los ingreses).
              </p>
              <p>
                Podés desactivar o configurar cookies desde tu navegador, aunque algunas funciones del Sitio podrían dejar de funcionar correctamente si lo hacés.
              </p>
            </div>
          </section>

          {/* 5. Compartir información */}
          <section>
            <h2 className="text-2xl font-bold text-[#2d3c5d] mb-4">5. Compartir información</h2>
            <div className="text-gray-700 space-y-3">
              <p>
                Podemos compartir información con terceros (por ejemplo, servicios de análisis o publicidad) siempre que respeten estándares de confidencialidad.
              </p>
              <p>
                También podremos divulgar datos si lo exige la ley, una orden judicial o autoridad competente, o para proteger nuestros derechos o los de terceros.
              </p>
            </div>
          </section>

          {/* 6. Derechos de los usuarios */}
          <section>
            <h2 className="text-2xl font-bold text-[#2d3c5d] mb-4">6. Derechos de los usuarios</h2>
            <div className="text-gray-700 space-y-3">
              <p>
                Tenés derecho a acceder, rectificar, modificar o eliminar tus datos personales. Para ello, enviá un correo con asunto "Acceso a Datos Personales" a{' '}
                <a href="mailto:info@decohomesinrival.com.ar" className="text-[#2d3c5d] hover:underline">
                  info@decohomesinrival.com.ar
                </a>
                , indicando claramente qué acción solicitás y tu identidad.
              </p>
              <p>
                La Empresa responderá tu solicitud dentro de un plazo razonable. En casos de esfuerzo técnico excesivo, podrá cobrarse un cargo administrativo razonable.
              </p>
            </div>
          </section>

          {/* 7. Seguridad */}
          <section>
            <h2 className="text-2xl font-bold text-[#2d3c5d] mb-4">7. Seguridad y confidencialidad</h2>
            <div className="text-gray-700 space-y-3">
              <p>
                Adoptamos medidas razonables para proteger tus datos contra acceso no autorizado, pérdida, modificación o divulgación. El acceso está restringido a empleados y contratistas con necesidad legítima.
              </p>
              <p>
                Sin embargo, tenés en cuenta que ningún sistema es completamente infalible, especialmente en el entorno de internet.
              </p>
            </div>
          </section>

          {/* 8. Transferencia */}
          <section>
            <h2 className="text-2xl font-bold text-[#2d3c5d] mb-4">8. Transferencia de la Empresa</h2>
            <p className="text-gray-700">
              En caso de fusión, venta o transferencia de activos, los datos recolectados podrán transferirse a la nueva entidad, siempre bajo condiciones de uso compatibilizados con esta Política.
            </p>
          </section>

          {/* 9. Menores */}
          <section>
            <h2 className="text-2xl font-bold text-[#2d3c5d] mb-4">9. Menores de edad</h2>
            <p className="text-gray-700">
              El Sitio y los servicios están disponibles únicamente para personas que tengan capacidad legal para contratar (mayores de 18 años). No se permite que menores envíen datos personales ni contraten a través del Sitio.
            </p>
          </section>

          {/* 10. Vigencia */}
          <section>
            <h2 className="text-2xl font-bold text-[#2d3c5d] mb-4">10. Vigencia y modificaciones</h2>
            <p className="text-gray-700">
              Esta política está vigente desde su publicación en el Sitio. Cuando haya cambios significativos, serán destacados para tu visibilidad. Si deseás recibir aviso por email de modificaciones, podés solicitarlo contactándonos.
            </p>
          </section>

          {/* Contacto */}
          <section className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#2d3c5d]">
            <h3 className="text-xl font-bold text-[#2d3c5d] mb-3">Contacto</h3>
            <p className="text-gray-700">
              Para cualquier consulta sobre esta Política de Privacidad, podés contactarnos en:{' '}
              <a href="mailto:info@decohomesinrival.com.ar" className="text-[#2d3c5d] hover:underline font-semibold">
                info@decohomesinrival.com.ar
              </a>
            </p>
          </section>

          {/* Botón volver */}
          <div className="pt-6">
            <Link
              to="/"
              className="inline-block px-6 py-3 rounded-lg font-semibold text-white transition"
              style={{ backgroundColor: '#2d3c5d' }}
            >
              Volver al inicio
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
